window.specialistService = {
    async getSpecialists(params = {}) {
        try {
            const requestBody = {
                limit: params.limit ?? 12,
                page: params.page ?? 1,
                isChild: params.isChild ?? false
            };

            const response = await fetch(window.appConfig.routes.getSpecialists, {
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': window.appConfig.csrfToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                return await response.json();
            }

            return { data: [] };

        } catch (error) {
            console.error('[SpecialistService] getSpecialists error:', error);
            throw error;
        }
    }
};